import { Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import ActionErrorMessage from '../../components/ActionErrorMessage';
import ClienteCard from './components/ClienteCard';
import { getCliente } from '../../redux/clienti/api';
import LoadingMask from '../../components/LoadingMask';

export default function Cliente() {
  const location = useLocation();
  const [clienteData, setClienteData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [loadingError, setLoadingError] = useState(null);

  const onPageLoad = async () => {
    setIsLoading(true);
    try {
      const response = await getCliente(location.state.id);
      setClienteData(response);
    } catch (error) {
      setLoadingError(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onPageLoad();
  }, [location.pathname]);

  return (
    <Stack>
      {loadingError != null && <ActionErrorMessage error={loadingError} />}
      {isLoading ? <LoadingMask /> : <></>}
      {clienteData != null ? <ClienteCard clienteData={clienteData} /> : <></>}
    </Stack>
  );
}
